import { createFeature, createReducer } from '@ngrx/store';

import { createTransactionDialogReducers } from './create-transaction-dialog.reducer';
import { createTransactionDialogInitialState } from './create-transaction-dialog.state';

export const createTransactionDialogFeature = createFeature({
    name: 'createTransactionDialog',
    reducer: createReducer(
        createTransactionDialogInitialState,
        ...createTransactionDialogReducers,
    ),
});
